import {createLocalizationContext} from "@variocube/cube-ui";
import * as cs from "./cs.json";
import * as de from "./de.json";
import * as en from "./en.json";
import * as et from "./et.json";
import * as fr from "./fr.json";
import * as it from "./it.json";
import * as no from "./no.json";
import * as pl from "./pl.json";
import * as tr from "./tr.json";

export const {LocalizationProvider, useLocalization, SUPPORTED_LANGUAGES} = createLocalizationContext({
  cs,
  de,
  en,
  et,
  fr,
  it,
  no,
  pl,
  tr,
});

export type MessageKey = keyof typeof en;